import { render, staticRenderFns } from "./TehtavaTable.vue?vue&type=template&id=258403fa&scoped=true"
import script from "./TehtavaTable.vue?vue&type=script&lang=js"
export * from "./TehtavaTable.vue?vue&type=script&lang=js"
import style0 from "./TehtavaTable.vue?vue&type=style&index=0&id=258403fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258403fa",
  null
  
)

export default component.exports